import Att from "public/techPartners/at&t.png";
import Cisco from "public/techPartners/cisco.png";
import Cogent from "public/techPartners/cogent.png";
import Cologix from "public/techPartners/cologix.png";
import Comcast from "public/techPartners/comcast.png";
import Eset from "public/techPartners/eset.png";
import Fortinet from "public/techPartners/fortinet.png";
import Inuvika from "public/techPartners/inuvika.png";
import PaloAlto from "public/techPartners/paloalto.png";
import Sophos from "public/techPartners/sophos.png";
import Teenable from "public/techPartners/teenable.png";
import Veeam from "public/techPartners/veeam.png";
import Virtuozzo from "public/techPartners/virtuozzo.png";
import Zadara from "public/techPartners/zadara.png";
import Vmware from "public/techPartners/vmwareArtboard-38.png";
import Taikun from "public/techPartners/taikunArtboard-93.png";
import Redhat from "public/techPartners/redhatArtboard-33.png";
import Opentext from "public/techPartners/opentextArtboard-70.png";
import Microsoft from "public/techPartners/microsoftArtboard-7.png";
import Juniper from "public/techPartners/juniperArtboard-53.png";
import Hpe from "public/techPartners/hpeArtboard-98.png";
import Eaton from "public/techPartners/eatonArtboard-100.png";
import Dell from "public/techPartners/dellArtboard-40.png";
import Checkpoint from "public/techPartners/checkpointArtboard-99.png";

export const TECH_PARTNERS_CONSTANTS = {
  title: "Our Technology Partners",
  list: [
    Cisco,
    Redhat,
    Cogent,
    Inuvika,
    Eset,
    Microsoft,
    Fortinet,
    Dell,
    PaloAlto,
    Cologix,
    Comcast,
    Sophos,
    Teenable,
    Veeam,
    Att,
    Virtuozzo,
    Zadara,
    Vmware,
    Taikun,
    Opentext,
    Juniper,
    Hpe,
    Eaton,
    Checkpoint,
  ],
};
